import {
    GET_TREND_ANGGOTA,
    GET_TREND_ANGGOTA_SUCCESS,
    GET_TREND_ANGGOTA_FAIL,

    GET_ANGGOTA_OVERVIEW,
    GET_ANGGOTA_OVERVIEW_SUCCESS,
    GET_ANGGOTA_OVERVIEW_FAIL,

    GET_ANGGOTA_PROVINSI,
    GET_ANGGOTA_PROVINSI_SUCCESS,
    GET_ANGGOTA_PROVINSI_FAIL,
    GET_ANGGOTA_KABKOT,
    GET_ANGGOTA_KABKOT_SUCCESS,
    GET_ANGGOTA_KABKOT_FAIL,
    GET_ANGGOTA_KECAMATAN,
    GET_ANGGOTA_KECAMATAN_SUCCESS,
    GET_ANGGOTA_KECAMATAN_FAIL,
  } from "./actionTypes";
  
  const initialState = {
    dataAnggotaTrend: {
      loading: false,
      error: false,
      data: null,
    },
    dataAnggotaOverview: {
      loading: false,
      error: false,
      data: null,
    },
    dataAnggotaProvinsi: {
      loading: false,
      error: false,
      data: null,
    },
    dataAnggotaKabkot: {
      loading: false,
      error: false,
      data: null,
    },
    dataAnggotaKecamatan: {
      loading: false,
      error: false,
      data: null,
    },
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      // get table exco pusat
      case GET_TREND_ANGGOTA:
        return {
          ...state,
          dataAnggotaTrend: {
            ...state.dataAnggotaTrend,
            loading: true,
            error: false,
          },
        };
      case GET_TREND_ANGGOTA_SUCCESS:
        return {
          ...state,
          dataAnggotaTrend: {
            ...state.dataAnggotaTrend,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_TREND_ANGGOTA_FAIL:
        return {
          ...state,
          dataAnggotaTrend: {
            ...state.dataAnggotaTrend,
            loading: false,
            error: action.payload,
          },
      };
      case GET_ANGGOTA_OVERVIEW:
        return {
          ...state,
          dataAnggotaOverview: {
            ...state.dataAnggotaOverview,
            loading: true,
            error: false,
          },
        };
      case GET_ANGGOTA_OVERVIEW_SUCCESS:
        return {
          ...state,
          dataAnggotaOverview: {
            ...state.dataAnggotaOverview,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_ANGGOTA_OVERVIEW_FAIL:
        return {
          ...state,
          dataAnggotaOverview: {
            ...state.dataAnggotaOverview,
            loading: false,
            error: action.payload,
          },
      };
      case GET_ANGGOTA_PROVINSI:
        return {
          ...state,
          dataAnggotaProvinsi: {
            ...state.dataAnggotaProvinsi,
            loading: true,
            error: false,
          },
        };
      case GET_ANGGOTA_PROVINSI_SUCCESS:
        return {
          ...state,
          dataAnggotaProvinsi: {
            ...state.dataAnggotaProvinsi,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_ANGGOTA_PROVINSI_FAIL:
        return {
          ...state,
          dataAnggotaProvinsi: {
            ...state.dataAnggotaProvinsi,
            loading: false,
            error: action.payload,
          },
      };
      case GET_ANGGOTA_KABKOT:
        return {
          ...state,
          dataAnggotaKabkot: {
            ...state.dataAnggotaKabkot,
            loading: true,
            error: false,
          },
        };
      case GET_ANGGOTA_KABKOT_SUCCESS:
        return {
          ...state,
          dataAnggotaKabkot: {
            ...state.dataAnggotaKabkot,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_ANGGOTA_KABKOT_FAIL:
        return {
          ...state,
          dataAnggotaKabkot: {
            ...state.dataAnggotaKabkot,
            loading: false,
            error: action.payload,
          },
      };
      case GET_ANGGOTA_KECAMATAN:
        return {
          ...state,
          dataAnggotaKecamatan: {
            ...state.dataAnggotaKecamatan,
            loading: true,
            error: false,
          },
        };
      case GET_ANGGOTA_KECAMATAN_SUCCESS:
        return {
          ...state,
          dataAnggotaKecamatan: {
            ...state.dataAnggotaKecamatan,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_ANGGOTA_KECAMATAN_FAIL:
        return {
          ...state,
          dataAnggotaKecamatan: {
            ...state.dataAnggotaKecamatan,
            loading: false,
            error: action.payload,
          },
      };
      default:
        return state;
    }
  };
  
  export default reducer;
  